// Configuración del entorno. Create React App solo expone al navegador las
// variables que empiezan por REACT_APP_ (ver frontend/.env.example).
// App nueva: proyecto Supabase y su clave publicable (pública por diseño; los datos los protegen las
// reglas RLS). En las pruebas no hay proyecto: se usa una dirección local que nunca se llama.
export const SUPABASE_URL = (process.env.REACT_APP_SUPABASE_URL || "http://localhost:54321").replace(/\/$/, "");
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || "clave-de-pruebas";
